import React from 'react';
import {Field} from 'formik'
import {
  CustomSelect
} from '@/components/form'

const initialFilters = {
  status: 'toreply'
}

const FilterForm = () => {
  const statuses = [
    { slug: 'toreply', label: 'To reply' },
    { slug: 'pending', label: 'Pending' },
    { slug: 'answered', label: 'Answered' },
    { slug: 'closed', label: 'Closed' },
    { slug: 'archived', label: 'Archived' },
    { slug: 'resolved', label: 'Resolved' },
  ];

  return (
    <>
      <Field
        default="Select status"
        component={CustomSelect}
        label="Status"
        name="status"
        options={statuses.map(s => ({
          value: s.slug,
          label: s.label
        }))}
      />
    </>
  )
}

export {FilterForm, initialFilters}
